<template>
  <!-- -->
  <div class="" style="height: 100%">
    <list-page>
      <list-table background-color="#FFF">
        <gant-table ref="grantTable" :data="siteList" height="100%"
                    :ganttConfig="{ planDate: 'planDate', actualityDate: 'actualityDate'}">
          <yq-table-column label="工地名称" prop="siteName" :fixed="true" width="240rem"/>
          <yq-table-column label="负责人" prop="leaderName" :fixed="true" :show-overflow-tooltip="true"/>
          <yq-table-column label="执行计划" prop="planDate" width="240rem">
            <template v-slot="{row}">
              <div class="plan-time">计划：{{ row.planDate }}</div>
              <div class="actuality-time">实际：{{ row.actualityDate }}</div>
            </template>
          </yq-table-column>
          <yq-table-column label="工地阶段" prop="sitePhase">
            <template v-slot="{row}">
              <c-custom-select value="dictCode" label="dictName" :data-list="stageList" :read-only="true"
                               v-model="row.sitePhase"/>
            </template>
          </yq-table-column>
          <yq-table-column label="工地进度" prop="status">
            <template v-slot="{row}">
              <el-tag v-if="row.status === 0" type="info">未开始</el-tag>
              <el-tag v-if="row.status === 1" type="success">进行中</el-tag>
              <el-tag v-if="row.status === 100" type="warning">已完成</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="option" fixed="right" width="120rem" align="center">
            <template #header>
              <table-button el-type="primary" @click="$router.push(`/project/site/detail?projectId=${projectId}`)">新增</table-button>
            </template>
            <template v-slot="{row}">
              <table-button-group>
                <table-button @click="$router.push(`/project/site/detail?id=${row.id}`)">查看</table-button>
<!--                <table-button @click="() => {currentSite = row; showStage = true}">修改进度</table-button>-->
              </table-button-group>
            </template>
          </yq-table-column>
        </gant-table>
      </list-table>
    </list-page>
    <el-dialog v-model="showStage" title="项目阶段" width="400px">
      <el-form label-width="70px">
        <el-form-item label="项目阶段">
          <c-custom-select value="dictCode" label="dictName" :data-list="stageList" v-model="selectPhase"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showStage = false">取消</el-button>
        <el-button type="primary" @click="save">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import GantTable from "@/components/h5/data/GantTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import projectApi from "@/api/dz-luqiao/luqiaoProjectApi";
import {watch} from "vue";
import commonApi from "@/api/commonApi";
import util from "@/util/util";
import siteApi from "@/api/dz-luqiao/luqiaoSiteApi";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ProjectSiteList",
  components: {
    TableButton, CCustomSelect,
    TableButtonGroup,
    YqTableColumn,
    ListPage, ListTable, GantTable
  },
  props: {
    projectId: {default: ""}
  },
  data() {
    return {
      siteList: [],
      stageList: [],
      showStage: false,
      selectPhase: "",
      currentSite: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    const user = await util.getUserInfo()
    this.stageList = await commonApi.queryDictionaryList("PROJECT_PHASE", user.merchantId)
    watch(() => this.projectId, async () => {
      if (this.projectId) {
        await this.query()
      }
    }, {deep: true, immediate: true})
  },
  methods: {
    init() {
    },
    async query() {
      this.siteList = this.handlerDate(await projectApi.querySiteByProjectId(this.projectId))
    },
    async save() {
      if (!this.selectPhase) {
        return
      }
      await siteApi.changeSitePhase(this.currentSite.id, this.selectPhase)
      await this.query()
      this.selectPhase = ""
      this.currentSite = {}
      this.showStage = false
      this.$message.success("保存成功")
    },
    handlerDate(list) {
      return list.map(item => {

        // 这里的实际时间和计划时间可能为空
        try {
          if(item.planStartTime && item.planEndTime){
            item.planDate = item.planStartTime.split(" ")[0] + " - " + item.planEndTime.split(" ")[0];
          }
          if (item.actualStartTime && item.actualEndTime) {
            item.actualityDate = item.actualStartTime.split(" ")[0] + " - " + item.actualEndTime.split(" ")[0];
          }
          return item;
        } catch (e) {
          return item;
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>

</style>